import type { Phone } from '../types'

/**
 * Compact owner label for admin list views. Empty string when ownerKind
 * is undefined (operator response — operator has only their own phones,
 * the column is irrelevant).
 *
 * - 'orphan'   → 'Свободна'
 * - 'admin'    → 'На админе'
 * - 'operator' → access-key label, falling back to 'key без метки'
 */
export function ownerLabel(phone: Phone): string {
  if (phone.ownerKind === undefined) return ''
  if (phone.ownerKind === 'orphan') return 'Свободна'
  if (phone.ownerKind === 'admin') return 'На админе'
  return phone.ownerLabel ?? 'key без метки'
}
